<template>
  <!-- page-wrapper Start-->
  <div class="page-wrapper">
    <div class="row">
      <div class="col-lg-7 blue-background d-none d-lg-block">
        <div class="content d-flex flex-column justify-content-between">
          <div class="row">
            <b-col md="{5}">
              <img
                alt=""
                src="../assets/images/white_logo.png"
                style="height: 70px;"
              >
            </b-col>

            <locale-changer />
          </div>

          <div>
            <div class="header">
              <h1>
                {{ $t('login.irktSahiblriZBizneslriniPortalVasitsilRahatlqlaIda') }}
              </h1>

              <p>
                {{ $t('login.satnalanVTdarkTkilatlarHmininLogistikaIrktlriVTrSa') }}
              </p>
            </div>

            <div class=" header ">
              <p>{{ $t('sccTtbiqiMobilTelefonunuzaYklyin') }}</p>
              <div class="row ">
                <div class="col-3">
                  <a
                    href="https://apps.apple.com/us/app/supply-chain-community-scc/id1581189724"
                    target="_blank"
                  >
                    <img
                      src="../assets/images/store/apple.png"
                      class="w-100"
                      :alt="$t('login.appStore')"
                    >
                  </a>
                </div>
                <div class="col-3">
                  <a
                    href="https://play.google.com/store/apps/details?id=az.scc.scc"
                    target="_blank"
                  >
                    <img
                      src="../assets/images/store/google.png"
                      class="w-100"
                      :alt="$t('login.playMarket')"
                    >
                  </a>
                </div>
                <div class="col-5 text-white">
                  {{ $t('login.mobilTtbiqlriYklyinVDahaOxImkanlardanIstifadEdin') }}
                </div>
              </div>
            </div>
          </div>
          <div class="row" />
          <div class="row" />
        </div>
      </div>

      <div class="col-lg-5 white-background">
        <div class="content">
          <div class="mb-4 d-block d-lg-none">
            <img
              alt=""
              src="../assets/images/big_logo.png"
              style="height: 70px;"
            >
          </div>


          <ul class="nav nav-pills login-tab">
            <li class="nav-item">
              <a
                class="nav-link"
                :class="{active: activeTab==='qr'}"
                href="#"
                @click="activeTab='qr'"
              >
                <i class="fa fa-qrcode mb-2" />
                {{ $t('login.qrKodla') }} <br>
                {{ $t('login.daxilOl') }}
              </a>
            </li>
            <li
              v-if="showLi"
              class="nav-item"
            >
              <a
                class="nav-link"
                :class="{active: activeTab==='asan'}"
                href="#"
                @click="activeTab='asan'"
              >
                <i class="fa fa-id-card mb-2" />
                {{ $t('login.asanLoginl') }} <br> {{ $t('login.daxilOl') }}
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                :class="{active: activeTab==='phone'}"
                href="#"
                @click="activeTab='phone'"
              >
                <i
                  class="fa"
                  :class="countryCode !== 'AZ' ? 'fa-envelope mb-2' : 'fa-mobile mb-2'"
                />
                {{ countryCode !== 'AZ' ? $t('login.emailIle') : $t('login.mobilNmr') }} <br> {{
                  $t('login.daxilOl')
                }}
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                :class="{active: activeTab==='registration' || activeTab==='otp'}"
                href="#"
                @click="activeTab='registration'"
              >
                <i class="fa fa-user-plus mb-2" />
                {{ $t('login.yeni') }} <br> {{ $t('login.qeydiyyat2') }}
              </a>
            </li>
          </ul>

          <div
            v-if="activeTab === 'qr'"
            class="card"
          >
            <div class="card-body">
              <h3>
                <i class="fa fa-qrcode mr-2" />
                {{ $t('login.qrKodIlDaxilOl') }}
              </h3>
              <p class="text-muted">
                <i class="fa fa-info-circle mr-2" />
                {{ $t('login.giriiTsdiqlmkNMobilTtbiqdSolMenyudanWebGiriBlmsini') }}
              </p>
            </div>

            <div class="card-body bg-light rounded m-3 p-5">
              <div
                v-if="webSessionKey"
                class="text-center qr-container"
              >
                <div class="qr-frame">
                  <img
                    :src="`${mediaBase}/qr/${webSessionKey}.png`"
                    class="qr-code"
                    alt="QR Code for login"
                  >
                  <div class="qr-overlay">
                    <div class="qr-corner qr-corner-tl" />
                    <div class="qr-corner qr-corner-tr" />
                    <div class="qr-corner qr-corner-bl" />
                    <div class="qr-corner qr-corner-br" />
                  </div>
                </div>
                <p class="mt-4 text-center text-muted">
                  <i class="fa fa-mobile-alt mr-2" />
                  {{ $t('login.scanQrWithMobile') || 'Scan this QR code with your mobile app' }}
                </p>
              </div>
              <div
                v-else
                class="alert alert-info d-flex align-items-center"
              >
                <i
                  class="fa fa-spinner fa-spin mr-3"
                  style="font-size: 1.5rem;"
                />
                <span>{{ $t('login.yklnir') }}</span>
              </div>
            </div>
          </div>

          <div
            v-if="activeTab === 'asan'"
            class="card"
          >
            <div class="card-body">
              <h3>Digital login </h3>
              <p class="text-bold">
                {{
                  $t('login.deletedDigital')
                }}
              </p>

              <!-- Step 1: Enter PIN -->
              <div v-if="currentStepAsan === 'pin'">
                <label>{{ $t('login.enterFin') }} </label>
                <input
                  v-model="fin"
                  type="text"
                  placeholder="e.g. 65JRCMA"
                  class="form-control"
                >
                <button
                  class="btn btn-primary mt-2"
                  @click="handleResetPassword"
                >
                  {{ $t('login.resetPasswordByFin') }}
                </button>
              </div>

              <!-- Step 2: Enter Phone if not found -->
              <div v-else-if="currentStepAsan === 'phone'">
                <label>{{ $t('login.enterPhoneNumber') }}</label>
                <VuePhoneNumberInput
                  v-model="asanPhone"
                  :default-country-code="countryCode"
                  :required="true"
                  :no-example="true"
                  @update="asanPhoneUpdated"
                  @phone-number-blur="asanPhoneBlur"
                />

                <button
                  class="btn btn-primary mt-2"
                  @click="submitPhone"
                >
                  {{ $t('body.gndr') }}
                </button>
              </div>

              <!-- Step 3: OTP Confirmation -->
              <div v-else-if="currentStepAsan === 'otp'">
                <label>{{ $t('login.enterOtp4Digit') }}</label>
                <input
                  v-model="asanOtp"
                  type="text"
                  maxlength="4"
                  placeholder="Enter OTP"
                  class="form-control"
                >
                <button
                  class="btn btn-primary mt-2"
                  @click="submitOtp"
                >
                  {{ $t('body.gndr') }}
                </button>
              </div>

              <!-- Step 4: New Password -->
              <!-- Step 4: New Password -->
              <div v-else-if="currentStepAsan === 'newPassword'">
                <label>Yeni şifrəni əlavə edin:</label>
                <div class="input-group mb-2">
                  <input
                    v-model="newPassword"
                    :type="passwordVisible ? 'text' : 'password'"
                    placeholder="**********"
                    class="form-control"
                  >
                  <div class="input-group-append">
                    <button
                      type="button"
                      class="btn btn-light"
                      @click.prevent="passwordVisible = !passwordVisible"
                    >
                      <i :class="passwordVisible ? 'fa fa-eye-slash' : 'fa fa-eye'" />
                    </button>
                  </div>
                </div>
                <ul
                  v-if="scoreNewPassword.unmetRequirements.length"
                  class="text-danger mt-2"
                >
                  <li
                    v-for="req in scoreNewPassword.unmetRequirements"
                    :key="req"
                  >
                    {{ req }}
                  </li>
                </ul>
                <div class="progress mb-3">
                  <div
                    class="progress-bar"
                    :class="`bg-${scoreNewPassword.color}`"
                    :style="{ width: scoreNewPassword.percent + '%' }"
                    role="progressbar"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    {{ scoreNewPassword.name }}
                  </div>
                </div>

                <label class="mt-2">{{ $t('login.passwordAgain') }}</label>
                <div class="input-group mb-2">
                  <input
                    v-model="confirmPassword"
                    :type="passwordVisible ? 'text' : 'password'"
                    placeholder="**********"
                    class="form-control"
                  >
                  <div class="input-group-append">
                    <button
                      type="button"
                      class="btn btn-light"
                      @click.prevent="passwordVisible = !passwordVisible"
                    >
                      <i :class="passwordVisible ? 'fa fa-eye-slash' : 'fa fa-eye'" />
                    </button>
                  </div>
                </div>
                <button
                  class="btn btn-primary mt-2"
                  :disabled="scoreNewPassword.percent < 100 || newPassword !== confirmPassword"
                  @click="submitNewPassword"
                >
                  {{ $t('login.changePassword') }}
                </button>
              </div>


              <!-- Success Message -->
              <div v-else-if="currentStepAsan === 'success'">
                <div class="alert alert-success">
                  {{ $t('login.passwordChanged') }}
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="activeTab === 'phone'"
            class="card"
          >
            <div class="card-body">
              <h3>{{ countryCode !== 'AZ' ? $t('login.emailIlDaxilOl') : $t('login.mobilNmrIlDaxilOl') }}</h3>
              <span>{{
                countryCode !== 'AZ' ? $t('login.sistemDaxilOlmaqNemailNmrniziVIfrniziDaxilEdin') : $t('login.sistemDaxilOlmaqNMobilNmrniziVIfrniziDaxilEdin')
              }}</span>
            </div>
            <div class="card-body">
              <div class="p-4 border border-secondary rounded">
                <form @submit.prevent="login">
                  <div
                    v-if="countryCode==='AZ'"
                    class="form-group"
                  >
                    <label class="col-form-label pt-0">
                      <i class="fa fa-mobile-alt mr-2" />
                      {{ $t('login.mobilNmr') }}
                    </label>
                    <div class="phone-input-wrapper">
                      <VuePhoneNumberInput
                        v-model="phone"
                        :default-country-code="countryCode"
                        :required="true"
                        :no-example="true"
                        @update="phoneUpdated($event)"
                        @phone-number-blur="phoneBlur($event)"
                      />
                    </div>
                  </div>
                  <div
                    v-else
                    class="form-group"
                  >
                    <label class="col-form-label pt-0">
                      <i class="fa fa-envelope mr-2" />
                      {{ $t('login.email') }}
                    </label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="fa fa-envelope" />
                        </span>
                      </div>
                      <input
                        v-model="phone"
                        class="form-control"
                        required
                        type="email"
                        placeholder="example@email.com"
                      >
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-form-label">
                      <i class="fa fa-lock mr-2" />
                      {{ $t('login.ifr') }}
                    </label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="fa fa-lock" />
                        </span>
                      </div>
                      <input
                        v-model="password"
                        autocomplete="current-password"
                        class="form-control"
                        required
                        :type="passwordVisible ? 'text' : 'password'"
                        placeholder="••••••••"
                      >
                      <div class="input-group-append">
                        <button
                          type="button"
                          class="btn btn-light"
                          @click.prevent="passwordVisible = !passwordVisible"
                        >
                          <i :class="passwordVisible ? 'fa fa-eye-slash' : 'fa fa-eye'" />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group form-row mt-4 mb-0 d-flex justify-content-between align-items-center">
                    <button
                      class="btn btn-primary px-5"
                      type="submit"
                    >
                      <i class="fa fa-sign-in mr-2" />
                      {{ $t('login.giri') }}
                    </button>

                    <button
                      type="button"
                      class="btn btn-link"
                      @click="activeTab='forget'"
                    >
                      <i class="fa fa-question-circle mr-1" />
                      {{ $t('login.ifrmiUnutmuam') }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div
            v-if="activeTab === 'forget'"
            class="card"
          >
            <div class="card-body">
              <h3>{{ $t('login.ifrnziUnutmusunuz') }}</h3>
              <span>{{ $t('login.mobilNmrniziDaxilEdinVIfrniziYenilyin') }}</span>
            </div>
            <div class="card-body">
              <div class="p-4 border border-secondary rounded">
                <form @submit.prevent="forget">
                  <div class="form-group">
                    <label class="col-form-label pt-0">{{ $t('login.mobilNmr') }}</label>
                    <VuePhoneNumberInput
                      v-model="phone"
                      :default-country-code="countryCode"
                      :required="true"
                      :no-example="true"
                      @update="phoneUpdated($event)"
                      @phone-number-blur="phoneBlur($event)"
                    />
                  </div>
                  <div class="form-group form-row mt-3 mb-0 d-flex justify-content-between align-items-center">
                    <button
                      class="btn btn-primary px-4"
                      type="submit"
                    >
                      {{ $t('login.ifrmiYenil') }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div
            v-if="activeTab === 'forget_otp'"
            class="card"
          >
            <div class="card-body">
              <h3>{{ $t('login.ifrnziUnutmusunuz') }}</h3>
              <span>{{ $t('login.mobilNmrniziDaxilEdinVIfrniziYenilyin') }}</span>
            </div>
            <div class="card-body">
              <div class="p-4 border border-secondary rounded">
                <form @submit.prevent="forgetOtpVerify">
                  <div class="form-group">
                    <label class="col-form-label">{{
                      countryCode !== 'AZ' ? $t('login.mailGndrilmiSmsKod') : $t('login.nmrnizGndrilmiSmsKod')
                    }}</label>
                    <input
                      v-model="otp"
                      class="form-control"
                      required
                      type="number"
                    >
                  </div>

                  <div class="form-group form-row mt-3 mb-0">
                    <button
                      class="btn btn-primary px-4"
                      type="submit"
                    >
                      {{ $t('login.tsdiql') }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div
            v-if="activeTab === 'registration'"
            class="card"
          >
            <div class="card-body">
              <h3>
                <i class="fa fa-user-plus mr-2" />
                {{ $t('login.qeydiyyat') }}
              </h3>
              <p class="text-muted">
                <i class="fa fa-info-circle mr-2" />
                {{ $t('login.hesabYaratVFunksiyalardanIstifadEt') }}
              </p>
            </div>
            <div class="card-body">
              <div class="p-4 border border-secondary rounded">
                <form @submit.prevent="register">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="col-form-label">
                          <i class="fa fa-user mr-2" />
                          {{ $t('login.ad') }}
                        </label>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                              <i class="fa fa-user" />
                            </span>
                          </div>
                          <input
                            v-model="name"
                            class="form-control"
                            required
                            type="text"
                            placeholder="John"
                          >
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="col-form-label">
                          <i class="fa fa-user mr-2" />
                          {{ $t('login.soyad') }}
                        </label>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                              <i class="fa fa-user" />
                            </span>
                          </div>
                          <input
                            v-model="surname"
                            class="form-control"
                            required
                            type="text"
                            placeholder="Doe"
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-form-label pt-0">
                      <i class="fa fa-mobile-alt mr-2" />
                      {{ $t('login.mobilNmr') }}
                    </label>
                    <div class="phone-input-wrapper">
                      <VuePhoneNumberInput
                        v-model="phone"
                        :default-country-code="countryCode"
                        :required="true"
                        :no-example="true"
                        @update="phoneUpdated($event)"
                        @phone-number-blur="phoneBlur($event)"
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-form-label">
                      <i class="fa fa-envelope mr-2" />
                      E-mail
                    </label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="fa fa-envelope" />
                        </span>
                      </div>
                      <input
                        v-model="email"
                        class="form-control"
                        required
                        type="email"
                        placeholder="example@email.com"
                      >
                    </div>
                  </div>
                  <div class="form-group form-row mt-4 mb-0">
                    <button
                      class="btn btn-primary btn-block py-2"
                      type="submit"
                    >
                      <i class="fa fa-check-circle mr-2" />
                      {{ $t('login.qeydiyyatdanKe') }}
                    </button>
                  </div>

                  <div class="mt-4 video-help-link">
                    <a
                      href="https://www.youtube.com/watch?v=-vgdeDkT-04"
                      target="_blank"
                      class="d-flex align-items-center justify-content-center"
                    >
                      <i
                        class="fa fa-play-circle mr-2"
                        style="font-size: 1.5rem;"
                      />
                      <span>{{ $t('login.registerVideo') }}</span>
                    </a>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div
            v-if="activeTab === 'otp'"
            class="card"
          >
            <div class="card-body">
              <h3>{{ $t('login.qeydiyyat') }}</h3>
              <span>{{ $t('login.hesabYaratVFunksiyalardanIstifadEt') }}</span>
            </div>
            <div class="card-body">
              <div class="p-4 border border-secondary rounded">
                <form @submit.prevent="otpVerify">
                  <div class="form-group">
                    <label class="col-form-label">{{
                      countryCode !== 'AZ' ? $t('login.mailGndrilmiSmsKod') : $t('login.nmrnizGndrilmiSmsKod')
                    }}</label>
                    <input
                      v-model="otp"
                      class="form-control"
                      required
                      type="number"
                    >
                  </div>

                  <div class="form-group form-row mt-3 mb-0">
                    <button
                      class="btn btn-primary px-4"
                      type="submit"
                    >
                      {{ $t('login.tsdiql') }}
                    </button>
                    <div
                      v-if="countdown > 0"
                      class="countdown"
                      style="margin-left: 30px"
                    >
                      {{ Math.floor(countdown / 60) }}:{{ String(countdown % 60).padStart(2, '0') }}
                    </div>

                    <div
                      v-if="countdown <= 0"
                      class=""
                    >
                      <button
                        style="margin-left: 30px"
                        class="btn btn-secondary px-4"
                        @click.prevent="resendRegister"
                      >
                        {{ $t('yenidn') }}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- login page end-->
  </div>
  <!-- latest jquery-->
</template>

<script>
import {
  checkPhone,
  generateASANSession,
  generateWebSession,
  getGeneralSettings,
  otpVerify,
  userForget,
  userForgetVerify,
  userLogin,
  userMe,
  userRegister,
  userSetASANPass,
  userVerifyOtpNew
} from "@/repositories/GeneralDataRepository";
import {baseUrl, mediaBase} from "@/repositories/Repository";

import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

import {Carousel, Slide} from 'vue-carousel';
import LocaleChanger from "@/components/locale_changer.vue";

export default {
  name: 'Login',
  components: {LocaleChanger, VuePhoneNumberInput, Carousel, Slide},
  data() {
    return {
      countdown: 120, // Countdown from 120 seconds (2 minutes)
      timer2: null,
      mediaBase: mediaBase,
      webSessionKey: null,
      timer: null,
      statistics: [],
      phone: '',
      password: '',
      name: '',
      surname: '',
      email: '',
      showLi: true,
      otp: '',
      activeTab: 'qr',
      phoneObject: null,
      countryCode: '',
      currentStepAsan: 'pin', // steps: 'pin' → 'phone' → 'otp' → 'newPassword' → 'success'
      fin: '',
      asanPhone: '',
      asanOtp: '',
      newPassword: '',
      confirmPassword: '',
      passwordVisible: false, // New: to toggle password visibility

    }
  },
  computed: {
    scoreNewPassword() {
      // If no new password, return default values.
      if (!this.newPassword) {
        return {
          name: '',
          percent: 0,
          color: 'danger',
          unmetRequirements: []
        };
      }
      let requirementsMet = 0;
      const unmetRequirements = [];

      // Check for minimum 8 characters
      if (this.newPassword.length >= 8) {
        requirementsMet++;
      } else {
        unmetRequirements.push(this.$t("passwordChange.requirementLength"));
      }

      // Check for uppercase letter
      if (/[A-Z]/.test(this.newPassword)) {
        requirementsMet++;
      } else {
        unmetRequirements.push(this.$t("passwordChange.requirementUpperCase"));
      }

      // Check for lowercase letter
      if (/[a-z]/.test(this.newPassword)) {
        requirementsMet++;
      } else {
        unmetRequirements.push(this.$t("passwordChange.requirementLowerCase"));
      }

      // Check for digit
      if (/\d/.test(this.newPassword)) {
        requirementsMet++;
      } else {
        unmetRequirements.push(this.$t("passwordChange.requirementDigit"));
      }

      // Check for special character
      if (/[!@#$%^&*(),.?":{}|<>]/.test(this.newPassword)) {
        requirementsMet++;
      } else {
        unmetRequirements.push(this.$t("passwordChange.requirementSpecialChar"));
      }

      const score = requirementsMet * 20;
      let strengthLabel = "";
      let color = "";
      switch (requirementsMet) {
        case 1:
          strengthLabel = this.$t("passwordChange.veryWeak");
          color = "danger";
          break;
        case 2:
          strengthLabel = this.$t("passwordChange.weak");
          color = "warning";
          break;
        case 3:
          strengthLabel = this.$t("passwordChange.moderate");
          color = "warning";
          break;
        case 4:
          strengthLabel = this.$t("passwordChange.moderate");
          color = "warning";
          break;
        case 5:
          strengthLabel = this.$t("passwordChange.strong");
          color = "success";
          break;
        default:
          strengthLabel = this.$t("passwordChange.veryWeak");
          color = "danger";
      }

      return {
        name: strengthLabel,
        percent: score,
        color: color,
        unmetRequirements: unmetRequirements,
      };
    },
  },
  mounted() {
    this.fetchCountryCode();

    getGeneralSettings().then(d => {
      this.statistics = d;
    })
    this.generateWebSession();

    this.timer = setInterval(() => {
      if (this.webSessionKey) {
        userMe(this.webSessionKey).then(({code}) => {

          if (code === 200) {
            localStorage.setItem('token', this.webSessionKey);
            clearInterval(this.timer);

            window.location.href = this.$route.query['next'] || '/';
          }
        });
      }
    }, 5000);

    setTimeout(() => {
      this.generateWebSession();
    }, 60000)

  },
  methods: {
    startCountdown() {
      this.timer2 = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          this.stopCountdown();
        }
      }, 1000);
    },
    stopCountdown() {
      clearInterval(this.timer2);
      this.timer2 = null;
    },
    async fetchCountryCode() {
      let ip;
      try {
        const response = await fetch("https://api.ipify.org/?format=json")
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        ip = data.ip;
      } catch (error) {
        console.error("Failed to fetch ip", error);
      }

      try {
        const response = await fetch(`${baseUrl}/country?ip=${ip}`);

        // Check if the response is okay (status code in the range 200-299)
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        const countryCode = data.countryCode;

        await this.$store.dispatch('auth/setCountry', countryCode); // Dispatch the action to update the Vuex state
        localStorage.setItem("country", countryCode);
        this.countryCode = countryCode

        // Update <li> tag visibility based on the country code
        this.showLi = (countryCode === "AZ");
        this.changeLanguage(countryCode === "AZ" ? 'az' : 'en');

      } catch (error) {
        // Handle the error here
        console.error("Failed to fetch country code:", error);
      }
    },
    changeLanguage(lang) {
      localStorage.setItem('userLang', lang); // Store selected language in localStorage
      this.$i18n.locale = lang;
    },
    phoneUpdated(event) {
      this.phoneObject = event;
      if (event.isValid) {
        this.phone = event.formattedNumber;
      }
    },
    phoneBlur() {
      if (this.phoneObject && this.phoneObject.isValid) {
        this.phone = this.phoneObject.formattedNumber;
      } else {
        this.phone = '';
      }
    },
    asanPhoneUpdated(event) {
      this.phoneObject = event;

      // Only update asanPhone if the number is valid
      if (event.isValid) {
        this.asanPhone = event.formattedNumber;
      }
    },
    asanPhoneBlur() {
      if (this.phoneObject && this.phoneObject.isValid) {
        this.asanPhone = this.phoneObject.formattedNumber;
      } else {
        this.asanPhone = '';
      }
    },

    login: function () {
      if (this.phone !== "" && this.password !== '') {
        let phone
        if (this.countryCode === 'AZ') {
          phone = this.phoneObject.formattedNumber.replace(/\D/g, '');

        } else {
          phone = this.phone;
        }

        userLogin(phone, this.password).then(({code, message, token}) => {

          if (code === 200) {
            localStorage.setItem("token", token);
            if (window.self !== window.top) {
              // If inside an iframe, open the redirect page in a new tab/window
              window.open(this.$route.query['next'] || '/', '_blank');
            } else {
              // If not inside an iframe, navigate as usual
              window.location.href = this.$route.query['next'] || '/';
            }
          } else if (code === 401) {
            this.$swal({
              title: this.$t("generalModal.warningTitle"),
              text: this.$t("login.nomreveyashifreyalnishdir"),
              icon: 'warning',
            })
          } else {
            this.$swal({
              title: `Error ${code} !`,
              text: message
            })
          }

        });
      }
    },

    forget: function () {
      if (this.phone !== "") {
        let phone = this.phoneObject.formattedNumber.replace(/\D/g, '');
        userForget(phone).then(({code, message, reason}) => {

          if (code === 200) {

            this.activeTab = 'forget_otp';


          } else if (code === 400) {
            this.$swal({
              title: this.$t("generalModal.warningTitle"),
              text: this.$t("login.nomreyalnishdir"),
              icon: 'warning',
            })
          } else if (code === 423) {
            this.$swal({
              title: this.$t("generalModal.warningTitle"),
              text: this.$t("login.bloklanib") + reason,
              icon: 'warning',
            })
          } else {
            this.$swal({
              title: `Error ${code} !`,
              text: message
            })
          }

        });
      }
    },


    forgetOtpVerify: function () {
      if (this.otp !== "") {
        let phone = this.phoneObject.formattedNumber.replace(/\D/g, '');
        let otp = this.otp.replace(/\D/g, '');
        userForgetVerify(phone, otp).then(({code, message, token}) => {

          if (code === 200) {
            localStorage.setItem("token", token);
            window.location.href = '/auth/changePassword';
          } else if (code === 401 || code === 404) {
            this.$swal({
              title: `Xəta !`,
              text: this.$t("login.shifreyalnishdir"),
              icon: 'error',
            })
          } else {
            this.$swal({
              title: `Error ${code} !`,
              text: message,
              icon: 'error',
            })
          }

        });
      }
    },
    resendRegister: function () {
      this.register();
      this.$swal({
        title: this.$t("generalModal.warningTitle"),
        text: this.$t("login.registerResend"),
        icon: 'warning',
      })
    },
    register: function () {
      if (this.phone !== "" && this.name !== '' && this.surname !== '' && this.email !== '') {
        let phone = this.phoneObject.formattedNumber.replace(/\D/g, '');
        userRegister(phone, this.email, this.name, this.surname, this.countryCode).then(({code, message, token}) => {

          if (code === 200) {
            localStorage.setItem("temp_token", token);
            this.startCountdown();
            this.activeTab = 'otp';
          } else if (code === 409) {
            if (this.countryCode === 'AZ') {
              this.$swal({
                title: this.$t("generalModal.warningTitle"),
                text: this.$t("login.alreadyReg"),
                icon: 'warning',
              })
            } else {
              this.$swal({
                title: this.$t("generalModal.warningTitle"),
                text: this.$t("login.alreadyRegXarici"),
                icon: 'warning',
              })
            }
          } else if (code === 410) {
            this.$swal({
              title: this.$t("generalModal.warningTitle"),
              text: this.$t("login.alreadyRegMail"),
              icon: 'warning',
            })
          } else {
            this.$swal({
              title: `Error ${code} !`,
              text: message,
              icon: 'error',
            })
          }

        });
      }
    },


    otpVerify: function () {
      if (this.otp !== "") {
        let otp = this.otp.replace(/\D/g, '');
        let temp_token = localStorage.getItem('temp_token');
        otpVerify(temp_token, otp).then(({code, message}) => {

          if (code === 200) {
            localStorage.setItem("token", temp_token);
            window.location.href = '/auth/changePassword';
          } else {
            this.$swal({
              title: `Error ${code} !`,
              text: this.$t("userCompanyAdminDetails.otpNotCorrect"),
              icon: 'error',
            })
          }

        });
      }
    },

    // Step 1: Handle reset password request with entered PIN
    async handleResetPassword() {
      if (!this.fin) {
        this.$swal("Please enter your PIN");
        return;
      }
      try {
        // Initially, asanPhone is empty so it should return hasPhone false
        const response = await checkPhone(this.fin, this.asanPhone);

        if (response.data.hasPhone === "false") {
          // Ask for phone number input
          this.currentStepAsan = 'phone';
        } else {
          // If already associated, move directly to OTP
          this.currentStepAsan = 'otp';
        }
      } catch (error) {
        console.error(error);
        this.$swal("Error checking phone");
      }
    },

    // Step 2: Submit phone number entered by user
    async submitPhone() {
      if (!this.asanPhone) {
        this.$swal("Please enter your phone number");
        return;
      }
      try {
        const response = await checkPhone(this.fin, '994' + this.asanPhone);
        if (response.data.hasPhone === "true") {
          this.currentStepAsan = 'otp';
        } else {
          this.$swal("The phone number is not found. Please check and try again.");
        }
      } catch (error) {
        console.error(error);
        this.$swal("Error checking phone");
      }
    },

    // Step 3: Submit OTP
    async submitOtp() {
      if (!this.asanOtp || this.asanOtp.length !== 4) {
        this.$swal("Please enter the 4-digit OTP");
        return;
      }
      try {
        const response = await userVerifyOtpNew('994' + this.asanPhone, this.asanOtp);
        if (response.isVerified) {
          this.currentStepAsan = 'newPassword';
        } else {
          this.$swal("OTP verification failed");
        }
      } catch (error) {
        console.error(error);
        this.$swal("Error verifying OTP");
      }
    },

    // Step 4: Submit new password
    async submitNewPassword() {
      if (!this.newPassword || this.newPassword !== this.confirmPassword) {
        this.$swal("Şifrələr uyğun gəlmir");
        return;
      }
      // Optionally, you can also check if the strength is 100%:
      if (this.scoreNewPassword.percent < 100) {
        this.$swal("Şifrə tələblərə uyğun deyil");
        return;
      }
      try {
        // Note: Adjust the phone formatting if needed.
        const formattedPhone = '994' + this.asanPhone;
        const response = await userSetASANPass(this.fin, formattedPhone, this.newPassword);
        if (response.phone) {
          this.currentStepAsan = 'success';
        } else {
          this.$swal("Failed to set new password");
        }
      } catch (error) {
        console.error(error);
        this.$swal("Error setting new password");
      }
    },
    generateWebSession() {
      generateWebSession().then(data => {
        if (data.code === 200) {
          this.webSessionKey = data.key
        } else {
          this.$swal({
            title: `Error ${data.code} !`,
            text: data.message,
            type: "error"
          }).then(() => {
            window.location.reload();
          })
        }
      })
    },

    asanSession() {
      generateASANSession().then(data => {
        if (data.code === 200) {
          window.location.href = 'https://asan.scc.az?transaction=' + data.key
        } else {
          this.$swal({
            title: `Error ${data.code} !`,
            text: data.message,
            type: "error"
          }).then(() => {
            window.location.reload();
          })
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
/* Modern Login Styling */
.asan-button {
  background: url('@/assets/images/asan.png') no-repeat center #FFFFff;
  background-size: 100% 100%;
  border: none;
}

.blue-background {
  background: linear-gradient(135deg, #1a237e, #283593, #3949ab);
  background-size: cover;
  padding: 50px;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('@/assets/images/login_bg.png') no-repeat right top;
    background-size: cover;
    opacity: 0.2;
    z-index: 0;
  }

  .content {
    position: relative;
    z-index: 1;
    min-height: calc(100vh - 100px);
    max-width: 650px;
    margin: 0 auto;

    .header {
      margin: 50px 0;

      h1 {
        font-family: var(--font-primary);
        font-size: 38px;
        font-weight: var(--font-weight-semibold);
        color: #fff;
        margin-bottom: 40px;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        letter-spacing: var(--letter-spacing-tight);
        line-height: var(--line-height-base);
      }

      p {
        font-family: var(--font-primary);
        font-size: 20px;
        color: white;
        line-height: var(--line-height-base);
        opacity: 0.9;
        font-weight: var(--font-weight-normal);
      }
    }

    .statistics-card {
      background: rgba(255, 255, 255, 0.15);
      color: white;
      margin-right: 10px;
      border-radius: 12px;
      backdrop-filter: blur(10px);
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
      transition: transform 0.3s ease, box-shadow 0.3s ease;

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
      }

      h4 {
        font-size: 30px;
        color: white;
        font-weight: 600;
      }

      span {
        color: white;
        font-size: 14px;
        opacity: 0.9;
      }

      .icon-bg {
        color: rgba(#1E44C6, 0.5);
      }
    }
  }
}

.white-background {
  background: #fff;
  box-shadow: -10px 0 30px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 2;

  .content {
    max-width: 550px;
    margin: 80px auto 20px;
    @media screen and (min-width: 1000px) {
      margin: 120px auto 20px;
    }
  }

  .login-tab {
    margin: 20px 0 30px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);

    .nav-item {
      flex: 1;
      margin: 0;

      .nav-link {
        border: none;
        color: #5D6B82;
        padding: 16px 20px;
        font-family: var(--font-primary);
        font-size: var(--font-size-base);
        line-height: var(--line-height-sm);
        text-align: center;
        transition: all 0.3s ease;
        border-bottom: 3px solid transparent;
        font-weight: var(--font-weight-medium);
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        i {
          margin-bottom: 8px;
          font-size: 1.2rem;
        }

        &.active {
          background: #f8f9fa;
          color: #3949ab;
          border-bottom: 3px solid #3949ab;
          font-weight: var(--font-weight-semibold);
        }

        &:hover:not(.active) {
          background: rgba(#f8f9fa, 0.5);
        }
      }
    }
  }

  .card {
    border: none;
    border-radius: 16px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    transition: all 0.3s ease;
    margin-bottom: 30px;

    .card-body {
      padding: 30px;

      h3 {
        font-family: var(--font-primary);
        font-weight: var(--font-weight-semibold);
        color: #333;
        margin-bottom: 15px;
        font-size: var(--font-size-lg);
        letter-spacing: var(--letter-spacing-tight);
      }

      span, label {
        font-family: var(--font-primary);
        color: #666;
        font-size: var(--font-size-md);
        font-weight: var(--font-weight-normal);
        line-height: var(--line-height-base);
      }

      p {
        font-family: var(--font-primary);
        line-height: var(--line-height-base);
        font-weight: var(--font-weight-normal);
      }
    }

    .bg-light {
      background-color: #f8f9fa !important;
    }
  }

  .form-control {
    height: 50px;
    border-radius: 10px;
    border: 1px solid #e0e0e0;
    padding: 10px 15px;
    font-size: var(--font-size-md);
    font-family: var(--font-primary);
    transition: all 0.3s ease;
    box-shadow: none;
    font-weight: var(--font-weight-normal);

    &:focus {
      border-color: #3949ab;
      box-shadow: 0 0 0 3px rgba(57, 73, 171, 0.1);
    }

    &::placeholder {
      color: #aaa;
      font-weight: var(--font-weight-light);
      opacity: 0.8;
    }
  }

  .btn {
    height: 50px;
    border-radius: 10px;
    font-family: var(--font-primary);
    font-weight: var(--font-weight-semibold);
    font-size: var(--font-size-md);
    letter-spacing: var(--letter-spacing-wide);
    transition: all 0.3s ease;

    &.btn-primary {
      background: linear-gradient(135deg, #3949ab, #1a237e);
      border: none;
      box-shadow: 0 4px 15px rgba(57, 73, 171, 0.3);

      &:hover {
        background: linear-gradient(135deg, #1a237e, #3949ab);
        box-shadow: 0 6px 20px rgba(57, 73, 171, 0.4);
        transform: translateY(-2px);
      }

      &:active {
        transform: translateY(0);
      }
    }

    &.btn-link {
      color: #3949ab;
      text-decoration: none;
      font-weight: var(--font-weight-medium);

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .input-group-append .btn {
    height: 50px;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  .p-4.border {
    border-radius: 12px !important;
    border: 1px solid #e0e0e0 !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
  }
}

::v-deep .VueCarousel-slide {
  margin-right: 0 !important;
}

::v-deep .VueCarousel-pagination {
  text-align: left;
}

.border-secondary {
  border-color: rgba(#20419E, 0.1) !important;
}

/* Progress bar styling */
.progress {
  height: 8px;
  border-radius: 4px;
  overflow: hidden;
  background-color: #e9ecef;

  .progress-bar {
    transition: width 0.5s ease;

    &.bg-danger {
      background: linear-gradient(to right, #ff5252, #ff1744) !important;
    }

    &.bg-warning {
      background: linear-gradient(to right, #ffab40, #ff9100) !important;
    }

    &.bg-success {
      background: linear-gradient(to right, #69f0ae, #00e676) !important;
    }
  }
}

/* Alert styling */
.alert {
  border-radius: 10px;
  padding: 15px 20px;

  &.alert-success {
    background-color: #e8f5e9;
    border-color: #c8e6c9;
    color: #2e7d32;
  }

  &.alert-info {
    background-color: #e3f2fd;
    border-color: #bbdefb;
    color: #1565c0;
  }
}

/* QR Code styling */
.qr-container {
  padding: 10px;
}

.qr-frame {
  position: relative;
  display: inline-block;
  padding: 15px;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: scale(1.02);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
  }
}

.qr-code {
  display: block;
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}

.qr-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.qr-corner {
  position: absolute;
  width: 20px;
  height: 20px;
  border-color: #3949ab;

  &.qr-corner-tl {
    top: 0;
    left: 0;
    border-top: 3px solid;
    border-left: 3px solid;
    border-top-left-radius: 8px;
  }

  &.qr-corner-tr {
    top: 0;
    right: 0;
    border-top: 3px solid;
    border-right: 3px solid;
    border-top-right-radius: 8px;
  }

  &.qr-corner-bl {
    bottom: 0;
    left: 0;
    border-bottom: 3px solid;
    border-left: 3px solid;
    border-bottom-left-radius: 8px;
  }

  &.qr-corner-br {
    bottom: 0;
    right: 0;
    border-bottom: 3px solid;
    border-right: 3px solid;
    border-bottom-right-radius: 8px;
  }
}

/* Phone input styling */
.phone-input-wrapper {
  ::v-deep .vue-phone-number-input {
    border-radius: 10px;
    overflow: visible;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    display: flex;

    .select-country-container {
      height: 45px;
      background-color: #f8f9fa;
      z-index: 10;
      .country-selector__input
      {
        height: 45px;

      }
    }

    .input-phone-number {
      height: 45px;
      flex: 1;
      margin-left: 2px;
      input {
        height: 45px;
        border-radius: 0;
        border: 1px solid #e0e0e0;
        padding: 10px 15px;
        font-size: 15px;
        transition: all 0.3s ease;

        &:focus {
          border-color: #3949ab;
          box-shadow: 0 0 0 3px rgba(57, 73, 171, 0.1);
        }
      }
    }
  }
}

/* Input group styling */
.input-group-text {
  background-color: #f8f9fa;
  border-color: #e0e0e0;
  color: #6c757d;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  width: 45px;
  justify-content: center;
}

/* Video help link styling */
.video-help-link {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 10px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);

  a {
    color: #e53935;
    text-decoration: none;
    font-weight: 600;
    font-size: 15px;
    transition: all 0.3s ease;

    &:hover {
      color: #c62828;
      transform: translateY(-2px);

      i {
        animation: pulse 1.5s infinite;
      }
    }

    i {
      color: #e53935;
      transition: all 0.3s ease;
    }

    span {
      color: #424242;
    }
  }

  &:hover {
    background-color: #f5f5f5;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
    transform: translateY(-3px);
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

/* Language-specific styles */
html[lang="az"] {
  .blue-background .content .header h1,
  .blue-background .content .header p,
  .card-body h3,
  .card-body p,
  .card-body span,
  .card-body label,
  .btn,
  .form-control,
  .login-tab .nav-item .nav-link {
    letter-spacing: var(--letter-spacing-normal);
  }
}

html[lang="ru"] {
  .blue-background .content .header h1,
  .blue-background .content .header p,
  .card-body h3,
  .card-body p,
  .card-body span,
  .card-body label,
  .btn,
  .form-control,
  .login-tab .nav-item .nav-link {
    letter-spacing: var(--letter-spacing-normal);
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .blue-background {
    padding: 30px;

    .content .header {
      margin: 30px 0;

      h1 {
        font-size: 28px;
      }

      p {
        font-size: 16px;
      }
    }
  }

  .white-background .content {
    margin: 50px auto 20px;
  }

  .login-tab .nav-item .nav-link {
    padding: 12px 15px;
    font-size: var(--font-size-sm);

    i {
      font-size: 1rem;
      margin-bottom: 6px;
    }
  }

  .qr-frame {
    padding: 10px;
  }

  .qr-corner {
    width: 15px;
    height: 15px;
  }

  .video-help-link {
    padding: 12px;

    a {
      font-size: var(--font-size-sm);
    }
  }
}
</style>
